module.exports = "/next-static/_next/static/images/hero_image_small-da25afb880ad4f9893ae39eb4f5ba524.webp";